/* eslint-disable jsx-a11y/anchor-is-valid */

import * as FabNewOrderButtonStyles from './FabNewOrderButton.styles';

import CloseIcon from '../../../../assets/icons/Close';
import QuoteIcon from '../../../../assets/icons/QuoteIcon';
import TaskIcon from '../../../../assets/icons/TaskIcon';
import useLinkTracker from '../../../../utils/tracking/useLinkTracker';
import { AppContextField } from '../../../../context/app/types';
import { OrderMode } from '../../../Orders/utils';
import { OrderStep } from '../../../OrderBuilder/utils/formState';
import { PrivateRoutePath, PublicRoutePath } from '../../../../utils/routes';
import { clearCart } from '../../../../store/cart/actions';
import { updateOrderSteps } from '../../../../context/app/actions';
import { useAppContextDispatch } from '../../../../context/app/AppContext';
import useOutsideClick from '../../../../v2/hooks/useOutsideClick';

import { useState, useRef } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import Link from '@mui/material/Link';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';

function FabNewOrderButton() {
  const { classes } = FabNewOrderButtonStyles.useFabStyles();

  const rootRef = useRef<HTMLElement>();

  const [showSubMenus, setShowSubMenus] = useState(false);

  useOutsideClick(rootRef, (_event) => setShowSubMenus(false));

  const dispatch = useDispatch();
  const { pathname } = useRouter();
  const appDispatch = useAppContextDispatch();

  const regex = /orders\/.*(new|edit)/g;
  const disabledOrderNow = pathname.match(regex);

  const orderClick = () => {
    dispatch(clearCart());
    appDispatch(
      updateOrderSteps({
        [AppContextField.ORDER_MODE]: OrderMode.NEW,
        [AppContextField.ORDER_STEP]: OrderStep.DETAILS,
        [AppContextField.ORDER_ID]: undefined,
        [AppContextField.QUOTE_ID]: undefined,
      })
    );
  };

  const quoteLinkRef = useLinkTracker('NEW_QUOTE_BTN');

  const toggleSubMenus = () => {
    setShowSubMenus(!showSubMenus);
  };

  if (disabledOrderNow) return null;

  return (
    <Box ref={rootRef}>
      {showSubMenus && (
        <Box className={classes.subMenusBox}>
          <Link ref={quoteLinkRef} href={PublicRoutePath.QUOTE_PROCESS_LOGIN} className={classes.buttonWrapper}>
            <Box className={classes.buttonText}>Get a quote</Box>
            <Box className={classes.iconWrapper}>
              <QuoteIcon />
            </Box>
          </Link>
          <Link
            data-testid="book-concrete-btn"
            href={PrivateRoutePath.NEW_ORDER}
            onClick={orderClick}
            className={classes.buttonWrapper}
          >
            <Box className={classes.buttonText}>Book concrete</Box>
            <Box className={classes.iconWrapper}>
              <TaskIcon />
            </Box>
          </Link>
        </Box>
      )}
      <Fab onClick={toggleSubMenus} className={classes.root} aria-label="new order">
        {showSubMenus ? <CloseIcon fontSize="small" dark /> : <AddIcon fontSize="large" color="primary" />}
      </Fab>
    </Box>
  );
}

export default FabNewOrderButton;
